module.exports = __webpack_public_path__ + "../resources/images/illustration_task-023cc0d11082abcf4dae8c9f2ff4c59b.svg";